module.exports = __webpack_public_path__ + "img/cloth_g3_shirt-03.5eb13767.svg";